import React from 'react';
import { Global, css } from '@emotion/core';
import normalizeCss from 'emotion-normalize';
import { toolEditor } from 'fever-froala-editor/src/lib/cssFroala';
import { BUILD_ID } from 'config/envVariable';

const hash = BUILD_ID && `?${BUILD_ID}`;

function GlobalCss({ fontFamily }) {
    return (
        <Global
            styles={css`
                @import url('https://utility.fevercdn.com/font/style/fonts.css');
                @import url('https://utility.fevercdn.com/icon-font/fever-icon-font.css.gz${hash}');
                ${normalizeCss}
                body {
                    font-family: "${fontFamily}";
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    letter-spacing: 0.1em;
                }

                html,
                body {
                    height: 100%;
                    width: 100%;
                }

                #root {
                    height: 100%;
                    width: 100%;
                }

                * {
                    box-sizing: border-box;
                }

                // scrollbar custom css
                .ScrollbarsCustom-Track {
                    background: #f8f8f8 !important;
                    border-radius: 4px !important;
                }

                .ScrollbarsCustom-Thumb {
                    background: #ccc !important;
                    border-radius: 4px !important;
                    &:hover {
                        background: #9b9b9b !important;
                    }
                }
                ${toolEditor}
                ${muiDisabledStyle}
                ${transitionFadeStyle}
                ${animationGradientBgStyle}
            `}
        />
    );
}

export default GlobalCss;

const muiDisabledStyle = css`
    .MuiButtonBase-root.Mui-disabled,
    .MuiSelect-select.Mui-disabled,
    .MuiInputBase-input.Mui-disabled {
        cursor: not-allowed;
        pointer-events: auto;
        &:active {
            pointer-events: none;
        }
    }
    .MuiButtonBase-root.MuiSwitch-switchBase.Mui-disabled {
        pointer-events: initial;
    }
    .MuiButtonBase-root,
    .MuiTypography-button {
        text-transform: initial;
    }
`;

const transitionFadeStyle = css`
    .fever-fade-next-enter {
        opacity: 0;
        transform: translateX(5%);
    }
    .fever-fade-next-enter-active {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-next-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-next-exit-active {
        display: none;
    }
    .fever-fade-next-enter-active {
        transition: all 200ms ease-in-out;
    }

    .fever-fade-prev-enter {
        opacity: 0;
        transform: translateX(-5%);
    }
    .fever-fade-prev-enter-active {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-prev-exit {
        opacity: 1;
        transform: translateX(0%);
    }
    .fever-fade-prev-exit-active {
        display: none;
    }
    .fever-fade-prev-enter-active {
        transition: all 200ms ease-in-out;
    }
`;

export const animationGradientBgStyle = css`
    .fever-anim-gradient-bg {
        background: linear-gradient(-45deg, #eee, #aaa, #ddd, #999);
        background-size: 400% 400%;
        animation: fever-gradient-bg 15s ease infinite;
    }

    @keyframes fever-gradient-bg {
        0% {
            background-position: 0% 50%;
        }
        50% {
            background-position: 100% 50%;
        }
        100% {
            background-position: 0% 50%;
        }
    }
`;
